export default __webpack_public_path__ + "test_img.jpg";